import { FileText, Plus } from "lucide-react";
import React from "react";

interface NavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  existingTemplates: any[];
}

const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  setActiveTab,
  existingTemplates,
}) => {
  return (
    <div className="bg-white rounded-2xl p-2 shadow-xl border border-indigo-100 mb-8">
      <div className="flex space-x-2">
        <button
          onClick={() => setActiveTab("create")}
          className={`flex-1 flex items-center justify-center space-x-2 py-3 px-4 rounded-xl font-medium transition-all duration-200 ${
            activeTab === "create"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg"
              : "text-gray-600 hover:bg-gray-50"
          }`}
        >
          <Plus className="w-5 h-5" />
          <span>Create New Template</span>
        </button>
        <button
          onClick={() => setActiveTab("existing")}
          className={`flex-1 flex items-center justify-center space-x-2 py-3 px-4 rounded-xl font-medium transition-all duration-200 ${
            activeTab === "existing"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg"
              : "text-gray-600 hover:bg-gray-50"
          }`}
        >
          <FileText className="w-5 h-5" />
          <span>Existing Templates</span>
          <span className="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full font-semibold">
            {existingTemplates.length}
          </span>
        </button>
      </div>
    </div>
  );
};

export default Navigation;
